import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
// images
import menuBg from "../../assets/images/bg/menu/home.svg";
import Footer from "../../components/footer";
import FooterBottom from "../../components/footerBottom";
// components
import Header from "../../components/header";
import Hero from "../../components/home/hero";
import MainMenu from "../../components/mainMenu";
import SignupModal from "../../components/signupModal";
import { getPublicFeatureListAction } from "../upcomingFeatured/actions";
import { getHomeDataAction } from "./actions";
import "./style.scss";
import logo from "../../assets/images/logo.png";
import useReactRefresh from "../../hooks/useReactRefresh";

const About = React.lazy(() => import("../../components/home/about"));
const Company = React.lazy(() => import("../../components/home/company"));
const Horizon = React.lazy(() => import("../../components/home/horizon"));
const Membership = React.lazy(() => import("../../components/home/membership"));
const FeaturedResources = React.lazy(() => import("../../components/home/resources"));
const Service = React.lazy(() => import("../../components/home/service"));
const WhoPerfect = React.lazy(() => import("../../components/home/whoPerfect"));

const HomePage = (props) => {
  const cookie = new Cookies();

  const [openMenu, setOpenMenu] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [keyword, setKeyword] = useState("");

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  const handleOpenSignupModal = () => {
    if (cookie.get("user_token")) {
      toast.error("you are already logged in");
    } else {
      setIsModal(true);
    }
  };

  useEffect(() => {
    props.getHomeDataAction();
    props.getPublicFeatureListAction("paginate=3");
  }, []);

  useEffect(() => {
    if (props?.home_data?.keywords?.length > 0) {
      const dataKeyword = props?.home_data?.keywords;
      const pp = dataKeyword.toString();
      setKeyword(pp);
    }
  }, [props?.home_data?.keywords]);

  useReactRefresh()

  return (
    <>
      <Helmet>
        <title>Home - Clarity Cooperative</title>
        <meta name="description" content={props?.home_data?.excerpt} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={props?.home_data?.name} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={props?.home_data?.url} />
        <meta property="og:image" content={logo} />
        <meta property="og:site_name" content="clarity cooperative" />
        <meta property="og:description" content={props?.home_data?.excerpt} />
        <meta name="twitter:card" content={props?.home_data?.excerpt} />
        <meta property="twitter:domain" content="ccdev.brethren.io" />
        <meta property="twitter:url" content={props?.home_data?.url} />
        <meta name="twitter:title" content={props?.home_data?.name} />
        <meta name="twitter:description" content={props?.home_data?.excerpt} />
        <meta name="twitter:image" content={logo} />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleEmpty" blackLogo />

      <Hero openSignup={handleOpenSignupModal} data={props.home_data} />

      <About openSignup={handleOpenSignupModal} data={props.home_data} />
      <Service openSignup={handleOpenSignupModal} data={props.home_data} />
      <WhoPerfect openSignup={handleOpenSignupModal} data={props.home_data} />
      <FeaturedResources />
      <Membership openSignup={handleOpenSignupModal} data={props.home_data} />
      <Horizon data={props.home_data} feature_list={props.feature_list} />
      <Company openSignup={handleOpenSignupModal} data={props.home_data} />

      <Footer />
      <FooterBottom />
      <SignupModal show={isModal} onHide={() => setIsModal(false)} />
    </>
  );
};

const mapStateToProps = (state) => ({
  home_data: state.home.home_data,
  feature_list: state.feature.feature_list,
});

export default connect(mapStateToProps, {
  getHomeDataAction,
  getPublicFeatureListAction,
})(withRouter(HomePage));
